import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgInstagrapIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path d="M13.6562.25H6.3438A6.0937 6.0937 0 0 0 .25 6.3438v7.3124A6.094 6.094 0 0 0 6.3438 19.75h7.3124a6.094 6.094 0 0 0 6.0938-6.0938V6.3438A6.0937 6.0937 0 0 0 13.6562.25m4.2657 13.4062c0 2.3522-1.9135 4.2657-4.2657 4.2657H6.3438c-2.3522 0-4.2657-1.9135-4.2657-4.2657V6.3438c0-2.3522 1.9135-4.2657 4.2657-4.2657h7.3124c2.3522 0 4.2657 1.9135 4.2657 4.2657z" />
      <path d="M10 5.125a4.875 4.875 0 1 0 0 9.75 4.875 4.875 0 0 0 0-9.75m0 7.9219A3.0507 3.0507 0 0 1 6.9531 10c0-1.6807 1.3675-3.0469 3.0469-3.0469S13.0469 8.3193 13.0469 10c0 1.6794-1.3675 3.0469-3.0469 3.0469M15.2394 5.409a.6496.6496 0 1 0 0-1.299.6496.6496 0 0 0 0 1.299" />
    </g>
  </svg>
);
export default SvgInstagrapIcon;
